import React, { useEffect, useState } from 'react';
import Icon from '../AppIcon';

const Toast = ({ message, type = 'success', duration = 3500, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => onClose?.(), 300);
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const config = {
    success: {
      icon: 'CheckCircle2',
      gradient: 'linear-gradient(135deg, #F58A54, #F06F6B, #E0528A)',
      bg: '#FFF7F5',
      border: '#FECACA',
      text: '#9A3412',
    },
    error: {
      icon: 'XCircle',
      gradient: 'linear-gradient(135deg, #EF4444, #DC2626)',
      bg: '#FEF2F2',
      border: '#FECACA',
      text: '#991B1B',
    },
    info: {
      icon: 'Info',
      gradient: 'linear-gradient(135deg, #3B82F6, #2563EB)',
      bg: '#EFF6FF',
      border: '#BFDBFE',
      text: '#1E40AF',
    },
  };

  const c = config?.[type] || config?.success;

  return (
    <div
      className={`flex items-center gap-3 px-4 py-3 rounded-2xl shadow-lg border transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'
      }`}
      style={{ backgroundColor: c?.bg, borderColor: c?.border, minWidth: '280px', maxWidth: '420px' }}
    >
      <div
        className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0"
        style={{ background: c?.gradient }}
      >
        <Icon name={c?.icon} size={16} className="text-white" />
      </div>
      <p className="text-sm font-semibold flex-1" style={{ color: c?.text }}>{message}</p>
      <button
        onClick={() => { setVisible(false); setTimeout(() => onClose?.(), 300); }}
        className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
      >
        <Icon name="X" size={14} />
      </button>
    </div>
  );
};

export const ToastContainer = ({ toasts, removeToast }) => (
  <div className="fixed bottom-6 right-6 z-[300] flex flex-col gap-3">
    {toasts?.map((toast) => (
      <Toast
        key={toast?.id}
        message={toast?.message}
        type={toast?.type}
        duration={toast?.duration}
        onClose={() => removeToast(toast?.id)}
      />
    ))}
  </div>
);

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const addToast = (message, type = 'success', duration = 3500) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type, duration }]);
  };

  const removeToast = (id) => {
    setToasts((prev) => prev?.filter((t) => t?.id !== id));
  };

  return { toasts, addToast, removeToast };
};

export default Toast;
